import React from 'react';
import { Link } from 'react-router-dom';
import { Star, ChevronRight } from 'lucide-react';
import { trackViewContent } from '../utils/analytics';

const HeroBanner = () => {
  return (
    <section className="relative w-full h-[520px] md:h-[600px] overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
          poster="https://images.unsplash.com/photo-1501555088652-021faa106b9b?w=1920&q=80"
        >
          <source 
            src="https://cdn.coverr.co/videos/coverr-hiking-in-the-mountains-4283/1080p.mp4" 
            type="video/mp4"
          />
        </video>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white px-4">
        {/* Trust Badge */}
        <div className="flex items-center gap-2 mb-6 bg-white/15 backdrop-blur-sm px-4 py-2 rounded-full">
          <div className="flex items-center gap-0.5">
            {[1, 2, 3, 4, 5].map((s) => (
              <Star key={s} size={14} fill="#C8D843" stroke="#C8D843" />
            ))}
          </div>
          <span className="text-sm font-medium">4.8 / 5 Puan — 100+ Mutlu Yorum</span>
        </div>

        {/* Main Heading */}
        <h1
          className="text-5xl md:text-7xl lg:text-8xl font-bold mb-4 tracking-tight leading-none"
          style={{ fontFamily: 'DM Sans, sans-serif' }}
        >
          Doğayı Keşfet
        </h1>

        {/* Subtitle */}
        <p className="text-lg md:text-xl max-w-xl mb-8 text-white/90 font-light">
          Uzman rehberler eşliğinde, küçük gruplarla açık hava maceralarına katıl
        </p>

        {/* CTA Button */}
        <Link
          to="/turlar"
          data-testid="hero-cta-tours"
          onClick={() => trackViewContent({ content_name: 'Tüm Maceralar', content_category: 'hero-cta' })}
          className="inline-flex items-center gap-2 bg-[#C8D843] text-[#1B1B1B] font-semibold px-8 py-3.5 rounded-full text-base hover:bg-[#b8c83a] transition-all duration-300 hover:scale-105 hover:shadow-lg"
          style={{ fontFamily: 'DM Sans, sans-serif' }}
        >
          Tüm Maceraları Gör
          <ChevronRight size={18} />
        </Link>
      </div>
    </section>
  );
};

export default HeroBanner;
